import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface MediaTypeDTO extends BaseIntDTO
{
  mediaTypeName: string;
}
